import React from "react";
import { caseStudies } from "../mock/mock";
import { ArrowUpRight } from "lucide-react";

const CaseStudies = () => {
  return (
    <section id="work" aria-labelledby="work-heading" className="relative py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-14">
          <div className="lg:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#6b6b66] mb-3">
              — (03) Selected work
            </p>
            <h2 id="work-heading" className="font-display text-3xl md:text-4xl font-medium leading-tight">
              Outcomes,<br />not outputs.
            </h2>
          </div>
          <div className="lg:col-span-9 lg:pt-8">
            <p className="font-display text-2xl md:text-[28px] leading-[1.3] font-light text-[#1a1a1a] max-w-3xl">
              A small sample of recent engagements where the work materially
              changed how brands appear inside AI-driven search.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10">
          {caseStudies.map((cs, i) => (
            <article
              key={cs.id}
              className={`group relative ${i % 2 === 1 ? "md:mt-16" : ""}`}
            >
              <div className="relative overflow-hidden bg-[#EFEFEA] aspect-[4/3]">
                <img
                  src={cs.image}
                  alt={cs.client}
                  className="absolute inset-0 w-full h-full object-cover grayscale-[40%] contrast-[1.05] group-hover:grayscale-0 group-hover:scale-[1.03] transition-all duration-700"
                />
                <div className="absolute top-4 left-4 right-4 flex items-start justify-between">
                  <span className="bg-[#FAFAF7] px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-[#0A0A0A]">
                    {cs.sector}
                  </span>
                  <span className="bg-[#0A0A0A] text-[#C8FF3D] px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] inline-flex items-center gap-1">
                    Case 0{i + 1}
                  </span>
                </div>
                <div className="absolute bottom-4 left-4 bg-[#C8FF3D] px-3 py-2">
                  <div className="font-display text-3xl md:text-4xl font-medium text-[#0A0A0A] leading-none">
                    {cs.metric}
                  </div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-[#0A0A0A] mt-1">
                    {cs.metricLabel}
                  </div>
                </div>
              </div>

              <div className="pt-6 flex items-start justify-between gap-4">
                <div className="min-w-0">
                  <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#6b6b66] mb-2">
                    {cs.client}
                  </p>
                  <h3 className="font-display text-2xl md:text-[28px] leading-tight font-medium">
                    {cs.headline}
                  </h3>
                  <p className="mt-3 text-[15px] text-[#2a2a2a] leading-relaxed max-w-xl">
                    {cs.summary}
                  </p>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {cs.tags.map((t) => (
                      <span
                        key={t}
                        className="font-mono text-[10px] uppercase tracking-[0.18em] px-2.5 py-1 border border-[#0A0A0A]/15 text-[#1a1a1a]"
                      >
                        {t}
                      </span>
                    ))}
                  </div>
                </div>
                <a
                  href="#contact"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
                  }}
                  aria-label="View case"
                  className="shrink-0 mt-1 h-11 w-11 rounded-full border border-[#0A0A0A] flex items-center justify-center group-hover:bg-[#0A0A0A] group-hover:text-[#C8FF3D] transition-colors"
                >
                  <ArrowUpRight className="h-4 w-4" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
